module.exports = __webpack_public_path__ + "static/culture.slogan-9fadb4ac0e68c74bf9a1fd863abf5670.png";